const rowsPerPageOptions = [8, 15, 25];
const defaultRowsPerPage = rowsPerPageOptions[0];

export { rowsPerPageOptions, defaultRowsPerPage };
